// Precision Wealth Financial Advisor WhatsApp Hotline
export const WHATSAPP_NUMBER = '27794984148';
export const WHATSAPP_MESSAGE = 'Hi Precision Wealth, I would like to speak to a financial adviser';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

// Public app URL (production) used for sharing / invites
export const APP_PUBLIC_URL = 'https://precisionwealthapp.co.za';
export const INVITE_MESSAGE = `I'm getting money-smart with Precision Wealth. Financial courses, quizzes, calculators and an AI money coach for all South Africans. Join me: ${APP_PUBLIC_URL}`;
export const INVITE_WHATSAPP_URL = `https://wa.me/?text=${encodeURIComponent(INVITE_MESSAGE)}`;

// Instagram (Behold.so live feed)
export const INSTAGRAM_HANDLE = 'precision_wealth';
export const INSTAGRAM_URL = 'https://www.instagram.com/precision_wealth';
export const BEHOLD_FEED_ID = 'RyG1kUstpiJeQfLke7Oo';
export const BEHOLD_FEED_URL = `https://feeds.behold.so/${BEHOLD_FEED_ID}`;
